export const CAPTIONS = {
  purchase: {
    descrip: null,
    show: false
  },
  down: {
    descrip: null,
    show: false
  },
  mortgage: {
    descrip: null,
    show: false
  },
  condo: {
    descrip: null,
    show: false
  },
  tax: {
    descrip: null,
    show: false
  },
  utilities: {
    descrip: "Electricity for AC, heating, hot water, town water/sewer, or other",
    show: false
  },
  insurance: {
    descrip: "Call your insurance agent to find out the cost of insuring this type of property and insert here",
    show: false
  },
  maint: {
    descrip: "Annual recurring maintanance and property management cost if you plan on spending to maintain building",
    show: false
  },
  trash: {
    descrip: "Estimated or historic trash collection",
    show: false
  },
  attorney: {
    descrip: null,
    show: false
  },
  inspection: {
    descrip: "Including environmental testing",
    show: false
  },
  closing: {
    descrip: "Lenders closing cost",
    show: false
  },
  points: {
    descrip: "Lenders points if applicable (these are tax deductable)",
    show: false
  },
  escrow: {
    descrip: null,
    show: false
  },
  repairs: {
    descrip: "Any immediate repair cost you might see ",
    show: false
  },
  rent1:{
    descrip: "The gross expected or actual monthly rent for the current lease year",
    show: false,
  },
  rent2:{
    descrip: "The monthly rent you expect to get for year two. A valuable calculation if there is rent adjustment",
    show: false
  },
  vacancy: {
    descrip: "Factor in that this unit may go vacant at times. Standard is 5%, it is not recommended to go below 2%.",
    show: false,
  },
  miscIncome:{
    descrip: "Income from coin op, laundry, soda machine, etc. that you can put on the property",
    show: false,
  },
  interest:{
    descrip: null,
    show: false,
  },
  grossExpenses1:{
    descrip: "Calculated field of all of your expenses for year one including mortgage, all recurring fees, and upfront costs",
    show: false,
  },
  grossExpenses2:{
    descrip: "Calculated field of all of your expenses for year two including mortgag and all recurring fees",
    show: false,
  },
  noi:{
    descrip: "Effective gross income minus all expenses",
    show: false,
  },
  noi2:{
    descrip: null,
    show: false,
  },
  equityDividendRate:{
    descrip: "Also known as cash on cash",
    show: false
  },
  roi:{
    descrip: "This is the pretax return on your investment. You will have additional credits on your tax returns due to the depreciation of your property",
    show: false,
  },
  roi2:{
    descrip: null,
    show: false,
  },
  equityIncrease:{
    descrip: null,
    show: false
  },
  equityIncrease2:{
    descrip: null,
    show: false
  },
  grossRentMult:{
    descrip: "Sales price over gross annual income",
    show: false
  },
  capRate:{
    descrip: null,
    show: false
  },
  capRate2:{
    descrip: null,
    show: false
  },
  ror:{
    descrip: "Calculation based on all money put into purchase and net cash flow at the end of the year (not including taxes or depreciation)",
    show: false
  }


}
